import React from 'react'
import { Spin } from 'antd'

export default () => (
  <Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />
)